import type { ReactNode } from "react";
import { Card, Grid, Typography } from "@mui/material";
import type { Metier } from "models";
import MetierActions from "../MetierActions";

interface MetierCardProps {
  metier: Metier;
  onMetierChanged: (metier: Metier) => void;
  onMetierDelete: (metier: Metier) => void;
}

function MetierCard({
  metier,
  onMetierChanged,
  onMetierDelete,
}: Readonly<MetierCardProps>): ReactNode {
  return (
    <Card variant="outlined" sx={{ width: "100%", paddingX: 2, paddingY: 1 }}>
      <Grid container size={12} sx={{ alignItems: "center" }}>
        <Typography fontWeight={600}>{metier.libelle}</Typography>
        <Grid size="grow" sx={{ justifyItems: "flex-end" }}>
          <Grid size="auto">
            <MetierActions
              metier={metier}
              onMetierChanged={onMetierChanged}
              onMetierDelete={onMetierDelete}
            />
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default MetierCard;
